import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TrailtestRoutingModule } from './trail-test-routing.module';
import { TrailtestComponent } from './trail-test.component';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';

@NgModule({
    imports: [
      FormsModule,
      CommonModule,
      TrailtestRoutingModule,
      ModalModule.forRoot()
    ],
    declarations: [
        TrailtestComponent
    ],
    providers: [BsModalRef],
    exports:[TrailtestComponent]
  
  })
  export class TrailtestModule { }